var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoVolantinointerattivoFree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640.37 93.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#05baee;}.cls-2{fill:#1d1d1b;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_2282",
    "data-name": "Tracciato 2282"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M576.88,77.92h-271a38.53,38.53,0,0,1-15-74,38.28,38.28,0,0,1,15-3h271a38.52,38.52,0,0,1,15,74A38.24,38.24,0,0,1,576.88,77.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.92,1.77A37.61,37.61,0,0,0,279.31,66a37.55,37.55,0,0,0,26.61,11h271a37.55,37.55,0,0,0,26.6-11,37.62,37.62,0,0,0-26.6-64.24h-271m0-1.77h271a39.4,39.4,0,0,1,0,78.8h-271a39.4,39.4,0,1,1,0-78.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.87,57,0,29.5H7.36l7.19,20.86h.22L22,29.5h7.3L18.28,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.49,57.5a15.41,15.41,0,0,1-11-4,13.42,13.42,0,0,1-4.29-10.27A13.41,13.41,0,0,1,35.52,33a15.41,15.41,0,0,1,11-4,15.38,15.38,0,0,1,10.93,4A13.44,13.44,0,0,1,61.7,43.22a13.45,13.45,0,0,1-4.28,10.27A15.38,15.38,0,0,1,46.49,57.5Zm-6-8.21a8,8,0,0,0,6,2.39,8.09,8.09,0,0,0,6-2.39,8.28,8.28,0,0,0,2.36-6.07,8.27,8.27,0,0,0-2.36-6.06,8.09,8.09,0,0,0-6-2.39,8,8,0,0,0-6,2.39,8.29,8.29,0,0,0-2.33,6.06A8.29,8.29,0,0,0,40.54,49.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.13,57V17.43H74V57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.25,29.5l6.86-.05V56.89h-6.86V51.46h-.11a10.17,10.17,0,0,1-4,4.42,11.48,11.48,0,0,1-6,1.56,12.75,12.75,0,0,1-9.63-4.06,14.14,14.14,0,0,1-3.87-10.16A14.3,14.3,0,0,1,83.52,33a12.7,12.7,0,0,1,9.63-4.09,11.31,11.31,0,0,1,6,1.59,10.24,10.24,0,0,1,4,4.45h.11ZM95.13,51.57v-.06a8.09,8.09,0,0,0,8.4-8.34,8.4,8.4,0,1,0-16.8,0,8.08,8.08,0,0,0,8.4,8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.28,29h-.06a9.9,9.9,0,0,1,7.57,3q2.81,3,2.8,8.12V57h-7V41.3A6.66,6.66,0,0,0,135,36.58a5.8,5.8,0,0,0-4.45-1.7,6.42,6.42,0,0,0-5,2.09,8.22,8.22,0,0,0-1.87,5.71V57h-6.86V29.56h6.86v5.38h0Q126.26,29,133.28,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.45,51.57l-.11.11a12.75,12.75,0,0,0,5-.94v5.71a19.56,19.56,0,0,1-6.91,1.1q-4.72,0-7.27-2.69a10.18,10.18,0,0,1-2.56-7.3V35.27h-5V30.16l1.75-.11c2.53-.14,3.86-1.66,4-4.56l.22-3.89h5.87v7.9h9.11v5.71H159.4V47.07Q159.4,51.57,164.45,51.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.88,23.77a5.95,5.95,0,0,1-7.52,0,4.54,4.54,0,0,1,0-6.76,5.95,5.95,0,0,1,7.52,0,4.54,4.54,0,0,1,0,6.76ZM174.66,57V29.5h6.86V57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.24,29h-.06a9.9,9.9,0,0,1,7.57,3q2.81,3,2.8,8.12V57h-7V41.3A6.66,6.66,0,0,0,207,36.58a5.8,5.8,0,0,0-4.45-1.7,6.42,6.42,0,0,0-5,2.09,8.22,8.22,0,0,0-1.87,5.71V57h-6.86V29.56h6.86v5.38h.05Q198.22,29,205.24,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.86,57.5a15.41,15.41,0,0,1-11-4,13.42,13.42,0,0,1-4.29-10.27A13.41,13.41,0,0,1,224.89,33a17,17,0,0,1,21.9,0,13.44,13.44,0,0,1,4.28,10.26,13.45,13.45,0,0,1-4.28,10.27A15.38,15.38,0,0,1,235.86,57.5Zm-6-8.21a8,8,0,0,0,6,2.39,8.09,8.09,0,0,0,6-2.39,8.28,8.28,0,0,0,2.36-6.07,8.27,8.27,0,0,0-2.36-6.06,8.09,8.09,0,0,0-6-2.39,8,8,0,0,0-6,2.39,8.29,8.29,0,0,0-2.33,6.06A8.29,8.29,0,0,0,229.91,49.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1089",
    "data-name": "Tracciato 1089",
    className: "cls-2",
    d: "M307.31,25a5.94,5.94,0,0,1-7.54,0,4.56,4.56,0,0,1-.35-6.42l.35-.35a6,6,0,0,1,7.54,0,4.56,4.56,0,0,1,.35,6.42Zm-7.23,32V29.54h7V57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1090",
    "data-name": "Tracciato 1090",
    className: "cls-2",
    d: "M330.7,29h0a10,10,0,0,1,7.53,3A11.24,11.24,0,0,1,341,40.1V57h-7V41.36a6.58,6.58,0,0,0-1.61-4.66A5.76,5.76,0,0,0,328.06,35,6.44,6.44,0,0,0,323,37.18a8.34,8.34,0,0,0-1.87,5.71V57.26H314.2V29.58h6.88V35h0A9.47,9.47,0,0,1,330.7,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1091",
    "data-name": "Tracciato 1091",
    className: "cls-2",
    d: "M362,51.66h-.11a12.73,12.73,0,0,0,5-.95v5.76a19.64,19.64,0,0,1-6.92,1.1,9.56,9.56,0,0,1-7.29-2.71,10.11,10.11,0,0,1-2.55-7.18V35.29H345V30.11h1.76q3.78-.22,4-4.57l.18-3.93h5.86v7.93H366v5.71h-9.09V47.13C356.88,50.14,358.57,51.66,362,51.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1092",
    "data-name": "Tracciato 1092",
    className: "cls-2",
    d: "M392.2,45.71h7.09a11.51,11.51,0,0,1-4.39,8.56,15.36,15.36,0,0,1-10,3.25,15,15,0,0,1-11-4,13.68,13.68,0,0,1-4.2-10.34,13.54,13.54,0,0,1,4.15-10.22,14.82,14.82,0,0,1,10.7-4,14.07,14.07,0,0,1,10.37,3.84,13.16,13.16,0,0,1,3.73,10.28H376.36a9,9,0,0,0,2.2,6.35,7.91,7.91,0,0,0,5.93,2.35,8.21,8.21,0,0,0,5.25-1.69A5.9,5.9,0,0,0,392.2,45.71ZM384.44,34a7.33,7.33,0,0,0-7.11,4.13h14A6.72,6.72,0,0,0,384.49,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1093",
    "data-name": "Tracciato 1093",
    className: "cls-2",
    d: "M420.46,29h0a9.37,9.37,0,0,1,1.06,0V35.8h-1.38q-8.79,0-8.79,10.61V57h-6.9V29.54H411v8.08h0Q413.2,29,420.46,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.46,29.54h6.87V57h-6.87V51.55h-.11a10.24,10.24,0,0,1-4,4.39,11.53,11.53,0,0,1-6,1.58,12.85,12.85,0,0,1-9.67-4.08,14.06,14.06,0,0,1-3.86-10.15A14.27,14.27,0,0,1,427.69,33a12.87,12.87,0,0,1,9.67-4.11,11.56,11.56,0,0,1,6,1.61,10.3,10.3,0,0,1,4,4.39h.11Zm-.84,13.75h0a8.37,8.37,0,1,0,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1095",
    "data-name": "Tracciato 1095",
    className: "cls-2",
    d: "M475.9,51.66h0a13.2,13.2,0,0,0,5-.95v5.76a19.75,19.75,0,0,1-6.94,1.1,9.5,9.5,0,0,1-7.27-2.71A10.14,10.14,0,0,1,464,47.68V35.29h-5V30.11h1.82q3.79-.22,4-4.57l.22-3.91h5.89v7.91h9.13v5.71h-9.2V47.13C470.85,50.14,472.52,51.66,475.9,51.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1096",
    "data-name": "Tracciato 1096",
    className: "cls-2",
    d: "M501,51.66h0a13.2,13.2,0,0,0,5-.95v5.76a19.75,19.75,0,0,1-6.94,1.1,9.63,9.63,0,0,1-7.29-2.71,10.16,10.16,0,0,1-2.66-7.18V35.29h-5.05V30.11h1.76q3.78-.22,4-4.57l.22-3.91h5.88v7.91h9.12v5.71h-9.12V47.13C495.93,50.14,497.6,51.66,501,51.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1097",
    "data-name": "Tracciato 1097",
    className: "cls-2",
    d: "M534.66,57l-10.88-27.5h7.3l7.2,20.91h.22l7.2-20.91H553l-11,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1098",
    "data-name": "Tracciato 1098",
    className: "cls-2",
    d: "M569.32,57.59a15.41,15.41,0,0,1-11-4,14.48,14.48,0,0,1,0-20.47h0a17,17,0,0,1,22,0,14.5,14.5,0,0,1,0,20.47h0A15.4,15.4,0,0,1,569.32,57.59Zm-6-8.22a8.66,8.66,0,0,0,11.95,0,9,9,0,0,0,0-12.16,8.64,8.64,0,0,0-11.95,0A9.07,9.07,0,0,0,563.36,49.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1099",
    "data-name": "Tracciato 1099",
    className: "cls-2",
    d: "M519.43,25a6,6,0,0,1-7.55,0,4.55,4.55,0,0,1-.35-6.42l.35-.35a6,6,0,0,1,7.55,0,4.55,4.55,0,0,1,.36,6.42C519.68,24.82,519.54,24.93,519.43,25Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1448",
    "data-name": "Raggruppa 1448"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1054",
    "data-name": "Rettangolo 1054",
    className: "cls-2",
    x: 497.62,
    y: 66.75,
    width: 3.01,
    height: 6.02
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1055",
    "data-name": "Rettangolo 1055",
    className: "cls-2",
    x: 512.67,
    y: 35.01,
    width: 6.02,
    height: 3.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1100",
    "data-name": "Tracciato 1100",
    className: "cls-2",
    d: "M521.7,69.76v-9h6v-3h-6V38h-3V69.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1101",
    "data-name": "Tracciato 1101",
    className: "cls-2",
    d: "M506.65,69.76h3v3h3V38h-3V66.75h-3v-3h-6v3h6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1056",
    "data-name": "Rettangolo 1056",
    className: "cls-2",
    x: 542.76,
    y: 66.75,
    width: 3.01,
    height: 12.04
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1102",
    "data-name": "Tracciato 1102",
    className: "cls-2",
    d: "M530.72,72.76v-9h6v-3h-9v12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1103",
    "data-name": "Tracciato 1103",
    className: "cls-2",
    d: "M536.74,63.74v9h3.12v-6h3v-3Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1447",
    "data-name": "Raggruppa 1447"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1057",
    "data-name": "Rettangolo 1057",
    className: "cls-2",
    x: 500.63,
    y: 72.76,
    width: 3.01,
    height: 3.01
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1058",
    "data-name": "Rettangolo 1058",
    className: "cls-2",
    x: 509.66,
    y: 84.8,
    width: 3.01,
    height: 6.02
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1104",
    "data-name": "Tracciato 1104",
    className: "cls-2",
    d: "M512.67,93.81h27.06v-3H512.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1059",
    "data-name": "Rettangolo 1059",
    className: "cls-2",
    x: 539.75,
    y: 81.81,
    width: 3.01,
    height: 6.02
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1060",
    "data-name": "Rettangolo 1060",
    className: "cls-2",
    x: 542.76,
    y: 78.78,
    width: 3.01,
    height: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1061",
    "data-name": "Rettangolo 1061",
    className: "cls-2",
    x: 536.7,
    y: 87.81,
    width: 3.01,
    height: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1062",
    "data-name": "Rettangolo 1062",
    className: "cls-2",
    x: 506.65,
    y: 81.81,
    width: 3.01,
    height: 3.01
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1063",
    "data-name": "Rettangolo 1063",
    className: "cls-2",
    x: 503.64,
    y: 75.77,
    width: 3.01,
    height: 6.02
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "499.13 69.32 500.63 66.75 503.64 65.61 506.65 66.75 511.17 68.66 512.67 38.02 515.02 36.51 518.69 38.02 520.19 52.38 520.19 59.27 527.72 60.73 533.32 62.73 536.74 63.74 542.76 66.75 544.26 69.76 542.76 81.81 541.26 85.89 539.71 87.81 538.2 89.84 537.85 91.66 513.62 91.66 512.67 90.86 511.56 88.53 509.66 84.8 506.65 81.79 503.64 75.77 500.63 72.77 499.13 69.32"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 497.62,
    y: 66.75,
    width: 3.01,
    height: 6.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "518.69 69.76 521.7 69.76 521.7 60.73 527.72 60.73 527.72 57.72 521.7 57.72 521.7 37.95 518.69 37.95 518.69 35.01 512.67 35.01 512.67 38.02 518.69 38.02 518.69 69.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "509.66 69.76 509.66 72.77 512.67 72.77 512.67 38.02 509.66 38.02 509.66 66.75 506.65 66.75 506.65 69.76 509.66 69.76"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 500.63,
    y: 63.74,
    width: 6.02,
    height: 3.01
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "542.87 66.75 542.87 63.74 536.74 63.74 536.74 72.77 539.86 72.77 539.86 66.75 542.76 66.75 542.76 78.78 542.76 81.81 545.77 81.81 545.77 78.78 545.77 66.75 542.87 66.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "530.72 72.77 530.72 63.74 536.74 63.74 536.74 60.73 527.72 60.73 527.72 72.77 530.72 72.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 500.63,
    y: 72.77,
    width: 3.01,
    height: 3.01
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "512.67 90.82 512.67 84.8 509.66 84.8 509.66 81.81 506.65 81.81 506.65 84.82 509.66 84.82 509.66 90.82 512.67 90.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 512.67,
    y: 90.86,
    width: 27.06,
    height: 2.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 539.75,
    y: 81.81,
    width: 3.01,
    height: 6.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 536.7,
    y: 87.81,
    width: 3.01,
    height: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 503.64,
    y: 75.77,
    width: 3.01,
    height: 6.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M625,2.43a9.68,9.68,0,0,1,12.83,0,8.23,8.23,0,0,1,2.53,6.2,8.22,8.22,0,0,1-2.53,6.2,9.67,9.67,0,0,1-12.84,0,8.24,8.24,0,0,1-2.52-6.2A8.27,8.27,0,0,1,625,2.43Zm6.4,12.73h0a6.66,6.66,0,0,0,4.83-1.85,6.24,6.24,0,0,0,1.91-4.68A6.23,6.23,0,0,0,636.27,4a7.22,7.22,0,0,0-9.65,0,6.23,6.23,0,0,0-1.91,4.67,6.26,6.26,0,0,0,1.89,4.68A6.57,6.57,0,0,0,631.41,15.16Zm4.1-8.25v0a2.75,2.75,0,0,1-.62,1.8,2.47,2.47,0,0,1-1.66.88l2.9,3.22h-3.31l-2.47-3v3h-2.59V4.27h4.68a3.28,3.28,0,0,1,2.21.72A2.39,2.39,0,0,1,635.51,6.91Zm-3.84-.58-1.32,0V8.25h1.32c.73,0,1.1-.32,1.1-1S632.4,6.33,631.67,6.33Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVolantinointerattivoFree);
export default __webpack_public_path__ + "static/media/logo_volantinointerattivo_free.5e9d69a900cd521afc12d92c9f590ed9.svg";
export { ForwardRef as ReactComponent };